import { keys, values } from '../../utils/javascript'

const countryData = {
  ke: {
    Nairobi: {
      Nairobi: ['00100', '00101', '00102', '00103'],
    },
  },
  tz: {
    'Dar Es Salaam': {
      'Dar Es Salaam': [11101, 11102, 11103, 11104],
    },
  },
  et: {
    'Addis Ababa': {
      'Addis Ababa': [1165],
    },
  },
}

const countryLabels = {
  ke: 'Kenya',
  tz: 'Tanzania',
  et: 'Ethiopia',
}

const countryOptions = keys(countryData).map(key => ({
  value: key,
  label: countryLabels[key],
}))

const stateOptions = values(countryData)
  .map(value => keys(value).map(state => ({ value: state, label: state })))
  .flat()

const cityOptions = values(countryData)
  .map(countryObj =>
    values(countryObj).map(stateObj =>
      keys(stateObj).map(city => ({ value: city, label: city })),
    ),
  )
  .flat(2)

const pincodeOptions = values(countryData)
  .map(countryObj =>
    values(countryObj).map(stateObj =>
      values(stateObj).map(pinArr =>
        pinArr?.map(pin => ({ value: pin, label: pin })),
      ),
    ),
  )
  .flat(3)

const getPincodeDetails = (country, state, city) => {
  let options = []
  if (!country && !state && !city) {
    options = pincodeOptions
  }
  if (country && !state && !city) {
    options = values(countryData?.[country])
      ?.map(stateObj =>
        values(stateObj)?.map(pinArr =>
          pinArr?.map(pin => ({ label: pin, value: pin })),
        ),
      )
      ?.flat(2)
  }
  if (country && state && !city) {
    options = values(countryData?.[country]?.[state])
      ?.map(pinArr =>
        pinArr?.map(pin => ({
          value: pin,
          label: pin,
        })),
      )
      .flat()
  }

  if (country && state && city) {
    options = countryData?.[country]?.[state]?.[city].map(pin => ({
      value: pin,
      label: pin,
    }))
  }
  return { options }
}

export {
  countryData,
  cityOptions,
  countryOptions,
  getPincodeDetails, //not used yet
  pincodeOptions,
  stateOptions,
  countryLabels,
}
